/* eslint-disable no-console */
import { useEffect } from "react";

import { config } from "@config";

const shouldDebug = false;

interface Logger {
  (message: string, ...rest: unknown[]): void;
}

const logger: Logger = (message: string, ...rest: unknown[]): void => {
  if (!shouldDebug) return;
  console.log(message, ...rest);
};

const useHermesSWRegistration = (isAuthenticated: boolean): void => {
  useEffect(() => {
    const shouldRegister =
      config.isProd() || (config.isStaging() && "serviceWorker" in navigator && isAuthenticated);

    if (!shouldRegister) return;

    const handleLoadWorker = (): void => {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        const alreadyRegistered = registrations.some(
          (reg) => reg.active && reg.active.scriptURL.endsWith("hermesSW.js"),
        );

        if (!alreadyRegistered) {
          navigator.serviceWorker
            .register("hermesSW.js", { type: "module" })
            .then((registration) => {
              logger("Service Worker registered:", registration);
            })
            .catch((error) => {
              logger("Service Worker registration failed:", error);
            });
        } else {
          logger("Service Worker already registered.");
        }
      });
    };

    window.addEventListener("load", handleLoadWorker);

    return () => {
      window.removeEventListener("load", handleLoadWorker);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useHermesSWRegistration;
